import React from 'react';

//component
import WmsInput from './../components/WmsInput/WmsInput.jsx';
import WmsCheckBox from '../components/WmsCheckBox/WmsCheckBox.jsx';
import WmsDropdown from './../components/WmsDropdown/WmsDropdown.jsx';
import WmsCollapse from './../components/WmsCollapse/WmsCollapse.jsx';
import WmsContainer from './../components/WmsContainer/WmsContainer.jsx';
import WmsRadio from './../components/WmsRadio/WmsRadio.tsx';

import * as GlobalService from './../global_services';

export class ItemsUofm extends React.Component {

    constructor(props) {

        super(props);

        this.translate = window.translate;

        this.state = {
            Selector: 'Item',
            customLabels: GlobalService.getCustomLabels(),
            Rights: GlobalService.GetRights()
        }
    }

    componentDidMount() {
        this.updateTotalAreaVolume(this.props.sharedItem, true);
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.sharedItem.ItemId != this.props.sharedItem.ItemId) {
            this.updateTotalAreaVolume(nextProps.sharedItem, true);
        }
    }

    normalizeProductIdTypeValue = (value) => {
        if (value === '' || typeof value === 'undefined') {
            return null;
        }
        return value;
    }

    getStandardizedProductIdTypeOptions = () => {
        const editOptions = this.props.sharedEditItemOptions && this.props.sharedEditItemOptions.StandardizedProductIdTypeOptions;
        const sharedOptions = this.props.sharedItemOptions && this.props.sharedItemOptions.StandardizedProductIdTypeOptions;
        if (editOptions && editOptions.length) {
            return editOptions;
        }
        if (sharedOptions && sharedOptions.length) {
            return sharedOptions;
        }
        const translated = this.translate('Options_StandardizedProductIdType');
        if (translated && translated !== 'Options_StandardizedProductIdType') {
            return translated.split(',').map((name) => ({ Name: name.trim() }));
        }
        return [
            { Name: 'UPC' },
            { Name: 'GTIN' },
            { Name: 'EAN' },
            { Name: 'ISBN' }
        ];
    }

    getProductIdTypeValueField = (options) => {
        if (options && options[0] && options[0].Value != null && typeof options[0].Value !== 'object') {
            return 'Value';
        }
        return 'Name';
    }

    renderStandardizedProductIdField = ({
        label,
        typeId,
        typeName,
        typeValue,
        typeOnChange,
        typeSelector,
        upcId,
        upcName,
        upcValue,
        upcOnChange,
        upcSelector,
        disabled
    }) => {
        const options = this.getStandardizedProductIdTypeOptions();
        const valueField = this.getProductIdTypeValueField(options);
        return (
            <div className={"standardized-product-id-field" + (disabled ? " disabled-upc" : "")}>
                <label htmlFor={typeId}>{label}</label>
                <div className="wms-input-group-wrapper">
                    <WmsDropdown
                        id={typeId}
                        name={typeName}
                        label={label}
                        noLabel={true}
                        wmsSelector={typeSelector}
                        onChangeFunc={disabled ? () => { } : typeOnChange}
                        value={typeValue == null ? '' : typeValue}
                        options={options}
                        valueField={valueField}
                        textField='Name'
                        parentClassName="select_box"
                        blankFirstOption={true}
                        blankFirstOptionText="Unspecified"
                        disabled={!!disabled} />
                    <WmsInput
                        id={upcId}
                        inputName={upcName}
                        wmsSelector={upcSelector}
                        onChangeFunc={disabled ? () => { } : upcOnChange}
                        label=""
                        value={upcValue}
                        parentClassName="input_box"
                        disabled={!!disabled} />
                </div>
            </div>
        );
    }

    handleChange = (param_parent_property, event) => {

        if (event.target.type == 'radio') {

            //set movableunit option  imperial or matrix radio button change
            this.handleMovableUnitSelectChange(this.props.sharedItem.UnitsOfMeasure.MovableUnit.MovableUnitUomIndex);

            let itemsObj = Object.assign(
                {},
                this.props.sharedItem,
                {
                    UnitsOfMeasure: Object.assign(
                        {},
                        this.props.sharedItem.UnitsOfMeasure,
                        {
                            [event.target.name]: !this.props.sharedItem.UnitsOfMeasure[event.target.name]
                        }
                    )
                }
            );

            this.updateTotalAreaVolume(itemsObj);

        } else {

            let parentObj = Object.assign({}, this.props.sharedItem.UnitsOfMeasure[param_parent_property]);
            if (event.target.type == 'checkbox') {
                parentObj[event.target.name] = event.target.checked;
                if (event.target.name === "UseSecondaryUnit") {
                    parentObj["SecondaryUnitType"] = "";
                }
            } else {
                parentObj[event.target.name] = event.target.name === 'StandardizedProductIdType'
                    ? this.normalizeProductIdTypeValue(event.target.value)
                    : event.target.value;
            }

            // Clear PackagingUnit fields when PackagingUom is set to "Unspecified"
            let shouldClearFields = false;
            if (param_parent_property === 'PackagingUnit' && event.target.name === 'PackagingUom') {
                const newValue = event.target.value;
                const isUnspecified = newValue == null || newValue === 0 || newValue === '' || newValue === 'Unspecified';
                
                if (isUnspecified) {
                    shouldClearFields = true;
                    const imperialMetricText = this.props.sharedItem.UnitsOfMeasure.IsImperial == true ? 'Imperial' : 'Metric';
                    // Clear all PackagingUnit fields
                    parentObj.InventoryUnitsPerUnit = null;
                    parentObj.Upc = null;
                    parentObj.StandardizedProductIdType = null;
                    parentObj['Length' + imperialMetricText] = null;
                    parentObj['Width' + imperialMetricText] = null;
                    parentObj['Height' + imperialMetricText] = null;
                    parentObj['Weight' + imperialMetricText] = null;
                    parentObj['NetWeight' + imperialMetricText] = null;
                    parentObj.IsPrepackaged = false;
                }
            }

            let itemsObj = Object.assign(
                {},
                this.props.sharedItem,
                {
                    UnitsOfMeasure: Object.assign(
                        {},
                        this.props.sharedItem.UnitsOfMeasure,
                        { [param_parent_property]: parentObj }
                    )
                }
            );

            if (param_parent_property === 'PackagingUnit' && (event.target.name === 'StandardizedProductIdType' || shouldClearFields)) {
                itemsObj.ItemBasics = Object.assign(
                    {},
                    itemsObj.ItemBasics,
                    {
                        Description: Object.assign(
                            {},
                            itemsObj.ItemBasics.Description,
                            { LabelingStandardizedProductIdType: parentObj.StandardizedProductIdType }
                        )
                    }
                );
            }
            
            // Clear total area and volume when fields are cleared
            if (shouldClearFields) {
                itemsObj.totalArea = "0.0000";
                itemsObj.totalVolume = "0.0000";
                itemsObj.totalActualVolume = 0;
            }
            
            // Update total area and volume when PackagingUom changes
            if (param_parent_property === 'PackagingUnit' && event.target.name === 'PackagingUom') {
                this.updateTotalAreaVolume(itemsObj);
            }
            
            this.props.onItemDataset(itemsObj);
            if (event.target.name == "InventoryUnitsPerUnit") {
                this.props.calculateCuftForRecStorage(itemsObj);
            }
        }
    }
    handleItemBasicChange = (param_parent_property, event) => {
        let parentObj = Object.assign({}, this.props.sharedItem.ItemBasics[param_parent_property]);
        const isProductIdTypeField = event.target.name === 'StandardizedProductIdType'
            || event.target.name === 'SecondaryStandardizedProductIdType';
        parentObj[event.target.name] = isProductIdTypeField
            ? this.normalizeProductIdTypeValue(event.target.value)
            : event.target.value;
        let itemsObj = Object.assign(
            {},
            this.props.sharedItem,
            {
                ItemBasics: Object.assign(
                    {},
                    this.props.sharedItem.ItemBasics,
                    { [param_parent_property]: parentObj }
                )
            }
        );
        this.props.onItemDataset(itemsObj);
    }

    static isPicklineEnabled(item) {
        if (typeof item.PicklineReplenishment === 'boolean') return item.PicklineReplenishment;
        return !!(item.Replenishment && (item.PicklineMin || item.PicklineMax || (item.MaxAllocateFromPickline > 0)));
    }

    static isBulkEnabled(item) {
        if (typeof item.BulkStorageReplenishment === 'boolean') return item.BulkStorageReplenishment;
        return !!(item.Replenishment && (item.BulkStorageMin || item.BulkStorageMax));
    }

    getDefaultMaxAllocate = (items) => {
        const val = parseFloat(items.UnitsOfMeasure?.PackagingUnit?.InventoryUnitsPerUnit);
        return (val > 0) ? val : 10;
    }

    syncReplenishmentState = (itemsObj) => {
        const pickOn = ItemsUofm.isPicklineEnabled(itemsObj);
        const bulkOn = ItemsUofm.isBulkEnabled(itemsObj);
        itemsObj.Replenishment = pickOn || bulkOn;
        itemsObj.ItemBasics.Replenishment = itemsObj.Replenishment;
        if (!pickOn) {
            itemsObj.MaxAllocateFromPickline = 0;
        } else if (!itemsObj.MaxAllocateFromPickline || parseFloat(itemsObj.MaxAllocateFromPickline) < 1) {
            itemsObj.MaxAllocateFromPickline = this.getDefaultMaxAllocate(itemsObj);
        }
    }

    handleChangeOfPickline = (event) => {
        const { name, value } = event.target;
        let itemsObj = Object.assign({}, this.props.sharedItem);
        itemsObj[name] = value;

        if (name === 'MaxAllocateFromPickline' && ItemsUofm.isPicklineEnabled(itemsObj)) {
            const parsed = parseFloat(value);
            if (!isNaN(parsed) && parsed < 1) itemsObj.MaxAllocateFromPickline = 1;
        }
        if (!itemsObj.PicklineMin) itemsObj.PicklineMax = null;

        const conversionMap = {
            PicklineMin:    ['PicklineMinPackagingUnit', itemsObj.UnitsOfMeasure.PackagingUnit.InventoryUnitsPerUnit],
            PicklineMax:    ['PicklineMaxPackagingUnit', itemsObj.UnitsOfMeasure.PackagingUnit.InventoryUnitsPerUnit],
            BulkStorageMin: ['BulkStorageMinMus',       itemsObj.UnitsOfMeasure.MovableUnit.Qty],
            BulkStorageMax: ['BulkStorageMaxMus',       itemsObj.UnitsOfMeasure.MovableUnit.Qty],
        };
        const entry = conversionMap[name];
        if (entry) {
            const [target, divisor] = entry;
            itemsObj[target] = divisor ? itemsObj[name] / divisor : "";
        }
        this.props.onItemDataset(itemsObj);
    }

    handleReplenishmentSectionToggle = (flagName) => {
        const isEnabled = flagName === 'PicklineReplenishment'
            ? ItemsUofm.isPicklineEnabled(this.props.sharedItem)
            : ItemsUofm.isBulkEnabled(this.props.sharedItem);
        let itemsObj = Object.assign({}, this.props.sharedItem);
        itemsObj[flagName] = !isEnabled;
        this.syncReplenishmentState(itemsObj);
        this.props.onItemDataset(itemsObj);
    }

    formatConversion = (count, unitLabel) => {
        if (count === '' || count == null || isNaN(count)) return '';
        const display = Number.isInteger(count) ? count : parseFloat(count).toFixed(2).replace(/\.?0+$/, '');
        return this.translate('Label_Replenishment_or_units').replace('{count}', display).replace('{unitLabel}', unitLabel);
    }

    renderQtyRow = (id, value, label, disabled, required, conversionValue, conversionUnit, unitsLabel) => {
        return (
            <div className='replenishment-qty-row'>
                <WmsInput
                    id={id}
                    inputName={id}
                    label={label}
                    wmsSelector={this.state.Selector + id}
                    onChangeFunc={this.handleChangeOfPickline}
                    value={value}
                    valueType={'number'}
                    disabled={disabled}
                    required={required}
                    extraWrapperClass="replenishment-qty-input-wrapper" />
                <div className='replenishment-qty-primary-group'>
                    <span className='replenishment-qty-units-label'>{unitsLabel}</span>
                </div>
                <div className='replenishment-conversion-readonly' aria-hidden={!conversionValue}>
                    {this.formatConversion(conversionValue, conversionUnit)}
                </div>
            </div>
        );
    }

    handlechangeForQty = (event) => {

        let movableUnitObj = Object.assign({}, this.props.sharedItem.UnitsOfMeasure.MovableUnit);
        movableUnitObj[event.target.name] = parseInt(event.target.value);
        movableUnitObj.Qty = movableUnitObj.High * movableUnitObj.Tie;

        let itemsObj = Object.assign(
            {},
            this.props.sharedItem,
            {
                UnitsOfMeasure: Object.assign(
                    {},
                    this.props.sharedItem.UnitsOfMeasure,
                    { 'MovableUnit': movableUnitObj }
                )
            }
        );
        this.props.onItemDataset(itemsObj);
    }

    handleMovableUnitSelectChange = (movableUnitIndex) => {

        let movableUnitObj = this.props.sharedItem.UnitsOfMeasure.MovableUnit;
        let movableUnitOptionObj = this.props.sharedItemOptions.MovableUnitOptions[movableUnitIndex];
        const previousUpc = movableUnitObj.Upc;
        const previousProductIdType = movableUnitObj.StandardizedProductIdType;
        if (typeof movableUnitOptionObj != 'undefined') {
            movableUnitObj = Object.assign({}, movableUnitOptionObj.Value);
            movableUnitObj.Qty = this.props.sharedItem.UnitsOfMeasure.MovableUnit.Qty;
            movableUnitObj['MovableUnitUomIndex'] = movableUnitIndex;
            movableUnitObj.Upc = previousUpc;
            movableUnitObj.StandardizedProductIdType = previousProductIdType;
        } else {
            movableUnitObj['MovableUnitUomIndex'] = '';
        }
        let itemsObj = Object.assign(
            {},
            this.props.sharedItem,
            {
                UnitsOfMeasure: Object.assign(
                    {},
                    this.props.sharedItem.UnitsOfMeasure,
                    {
                        'MovableUnit': movableUnitObj
                    }
                )
            }
        );
        this.props.onItemDataset(itemsObj);
    }

    handleChangeForTotalAreaVolume = (param_parent_property, event) => {
        let parentObj = Object.assign({}, this.props.sharedItem.UnitsOfMeasure[param_parent_property]);
        parentObj[event.target.name] = event.target.value;

        let itemsObj = Object.assign(
            {},
            this.props.sharedItem,
            {
                UnitsOfMeasure: Object.assign(
                    {},
                    this.props.sharedItem.UnitsOfMeasure,
                    { [param_parent_property]: parentObj }
                )
            }
        );
        this.updateTotalAreaVolume(itemsObj);
    }
    handleChangeForInventoryUnitTotalAreaVolume = (param_parent_property, event) => {
        let parentObj = Object.assign({}, this.props.sharedItem.UnitsOfMeasure.InventoryUnitOfMeasure[param_parent_property]);
        parentObj[event.target.name] = event.target.value;

        let itemsObj = Object.assign(
            {},
            this.props.sharedItem,
            {
                UnitsOfMeasure: Object.assign(
                    {},
                    this.props.sharedItem.UnitsOfMeasure,
                    {
                        InventoryUnitOfMeasure: Object.assign(
                            {},
                            this.props.sharedItem.UnitsOfMeasure.InventoryUnitOfMeasure,
                            {
                                [param_parent_property]: parentObj
                        })
                    }
                )
            }
        );
        this.updateInventoryUnitTotalAreaVolume(itemsObj);
    }
    updateInventoryUnitTotalAreaVolume = (param_itemsObj, initial = false) => {
        let length;
        let width;
        let height = 0;
        var divisor = (param_itemsObj.UnitsOfMeasure.IsImperial == true || param_itemsObj.UnitsOfMeasure.IsImperial == "true") ? 12 : 100;
        let imperialMetricText = param_itemsObj.UnitsOfMeasure.IsImperial == true ? 'Imperial' : 'Metric';
        let itemsObj = Object.assign({}, param_itemsObj);

        if (param_itemsObj.UnitsOfMeasure != null &&
            param_itemsObj.UnitsOfMeasure.InventoryUnitOfMeasure != null) {
            if (
                initial &&
                param_itemsObj.UnitsOfMeasure.InventoryUnitOfMeasure.PrimaryUnitOfMeasure &&
                param_itemsObj.UnitsOfMeasure.InventoryUnitOfMeasure.SecondaryUnitOfMeasure
            ) {
                let lengthP = parseFloat(param_itemsObj.UnitsOfMeasure.InventoryUnitOfMeasure.PrimaryUnitOfMeasure['Length' + imperialMetricText] || 0);
                let widthP = parseFloat(param_itemsObj.UnitsOfMeasure.InventoryUnitOfMeasure.PrimaryUnitOfMeasure['Width' + imperialMetricText] || 0);
                let heightP = parseFloat(param_itemsObj.UnitsOfMeasure.InventoryUnitOfMeasure.PrimaryUnitOfMeasure['Height' + imperialMetricText] || 0);
                let lengthS = parseFloat(param_itemsObj.UnitsOfMeasure.InventoryUnitOfMeasure.SecondaryUnitOfMeasure
['Length' + imperialMetricText] || 0);
                let widthS = parseFloat(param_itemsObj.UnitsOfMeasure.InventoryUnitOfMeasure.SecondaryUnitOfMeasure
['Width' + imperialMetricText] || 0);
                let heightS = parseFloat(param_itemsObj.UnitsOfMeasure.InventoryUnitOfMeasure.SecondaryUnitOfMeasure
                ['Height' + imperialMetricText] || 0);

                itemsObj['totalPrimaryArea'] = ((widthP / divisor || 0) * (lengthP / divisor || 0)).toFixed(4);
                itemsObj['totalSecondaryArea'] = ((widthS / divisor || 0) * (lengthS / divisor || 0)).toFixed(4);
                let cfP = (lengthP * widthP * heightP) / (divisor * divisor * divisor);
                let cfS = (lengthS * widthS * heightS) / (divisor * divisor * divisor);
                itemsObj['totalPrimaryVolume'] = cfP.toFixed(4);
                itemsObj['totalSecondaryVolume'] = cfS.toFixed(4);
                itemsObj['totalPrimaryActualVolume'] = cfP;
                itemsObj['totalSecondaryActualVolume'] = cfS;
            }
            else {
                if (param_itemsObj.UnitsOfMeasure.InventoryUnitOfMeasure.PrimaryUnitOfMeasure) {
                    length = parseFloat(param_itemsObj.UnitsOfMeasure.InventoryUnitOfMeasure.PrimaryUnitOfMeasure['Length' + imperialMetricText] || 0);
                    width = parseFloat(param_itemsObj.UnitsOfMeasure.InventoryUnitOfMeasure.PrimaryUnitOfMeasure['Width' + imperialMetricText] || 0);
                    height = parseFloat(param_itemsObj.UnitsOfMeasure.InventoryUnitOfMeasure.PrimaryUnitOfMeasure['Height' + imperialMetricText] || 0);
                    itemsObj['totalPrimaryArea'] = ((width / divisor || 0) * (length / divisor || 0)).toFixed(4);
                    let cf = (length * width * height) / (divisor * divisor * divisor);
                    itemsObj['totalPrimaryVolume'] = cf.toFixed(4);
                    itemsObj['totalPrimaryActualVolume'] = cf;
                }
                if (param_itemsObj.UnitsOfMeasure.InventoryUnitOfMeasure.SecondaryUnitOfMeasure) {
                    length = parseFloat(param_itemsObj.UnitsOfMeasure.InventoryUnitOfMeasure.SecondaryUnitOfMeasure
    ['Length' + imperialMetricText] || 0);
                    width = parseFloat(param_itemsObj.UnitsOfMeasure.InventoryUnitOfMeasure.SecondaryUnitOfMeasure
    ['Width' + imperialMetricText] || 0);
                    height = parseFloat(param_itemsObj.UnitsOfMeasure.InventoryUnitOfMeasure.SecondaryUnitOfMeasure
                    ['Height' + imperialMetricText] || 0);
                    itemsObj['totalSecondaryArea'] = ((width / divisor || 0) * (length / divisor || 0)).toFixed(4);
                    let cf = (length * width * height) / (divisor * divisor * divisor);
                    itemsObj['totalSecondaryVolume'] = cf.toFixed(4);
                    itemsObj['totalSecondaryActualVolume'] = cf;
                }
            }
        }
        this.props.onItemDataset(itemsObj, initial);
        this.props.calculateCuftForRecStorage(itemsObj);
    }

    updateTotalAreaVolume = (param_itemsObj, param_initObj) => {
        let length;
        let width;
        let height = 0;
        let imperialMetricText = param_itemsObj.UnitsOfMeasure.IsImperial == true ? 'Imperial' : 'Metric';

        if (param_itemsObj.UnitsOfMeasure != null &&
            param_itemsObj.UnitsOfMeasure.PackagingUnit != null) {

            length = parseFloat(param_itemsObj.UnitsOfMeasure.PackagingUnit['Length' + imperialMetricText] || 0);
            width = parseFloat(param_itemsObj.UnitsOfMeasure.PackagingUnit['Width' + imperialMetricText] || 0);
            height = parseFloat(param_itemsObj.UnitsOfMeasure.PackagingUnit['Height' + imperialMetricText] || 0);

        }

        var divisor = (param_itemsObj.UnitsOfMeasure.IsImperial == true || param_itemsObj.UnitsOfMeasure.IsImperial == "true") ? 12 : 100;

        let itemsObj = Object.assign({}, param_itemsObj);
        itemsObj['totalArea'] = ((width / divisor || 0) * (length / divisor || 0)).toFixed(4);

        let cf = (length * width * height) / (divisor * divisor * divisor);
        itemsObj['totalVolume'] = cf.toFixed(4);
        itemsObj['totalActualVolume'] = cf;

        let isFirstTimeObjSet = false;
        if (param_initObj) {
            isFirstTimeObjSet = true;
        }
        this.props.onItemDataset(itemsObj, isFirstTimeObjSet);
        this.props.calculateCuftForRecStorage(itemsObj);
        if (param_initObj) {
            this.updateInventoryUnitTotalAreaVolume(itemsObj, param_initObj);
        }
    }

    render() {
        const renderItems = this.props.sharedItem;
        const imperialMetricText = renderItems.UnitsOfMeasure.IsImperial == true ? 'Imperial' : 'Metric';
        var isAllowDuplicatedUPC = false;
        if (
            this.props.sharedCurrentCustomerObj &&
            this.props.sharedCurrentCustomerObj.options &&
            this.props.sharedCurrentCustomerObj.options.allowDuplicateUPCs
        ) {
            isAllowDuplicatedUPC = true;
        }
        const PackagingUnitObj = renderItems.UnitsOfMeasure.PackagingUnit;
        const picklineOn = ItemsUofm.isPicklineEnabled(renderItems);
        const bulkOn = ItemsUofm.isBulkEnabled(renderItems);
        const primaryUnitsLabel = this.translate('Label_Primary_Units').toLowerCase();
        const packagingUnitsLabel = this.translate('Label_Packaging_Units').toLowerCase();
        const musLabel = this.translate('Label_Mus');
        const minLabel = this.translate('Label_Minimum_quantity');
        const maxLabel = this.translate('Label_Maximum_quantity');
        const IsPrepackagedEnable = PackagingUnitObj['Weight' + imperialMetricText] != undefined
            && PackagingUnitObj['Weight' + imperialMetricText] != ""
            && parseInt(PackagingUnitObj['Weight' + imperialMetricText]) != 0
            && PackagingUnitObj['Height' + imperialMetricText] != undefined
            && PackagingUnitObj['Height' + imperialMetricText] != ""
            && parseInt(PackagingUnitObj['Height' + imperialMetricText]) != 0
            && PackagingUnitObj['Width' + imperialMetricText] != undefined
            && PackagingUnitObj['Width' + imperialMetricText] != ""
            && parseInt(PackagingUnitObj['Width' + imperialMetricText]) != 0
            && PackagingUnitObj['Length' + imperialMetricText] != undefined
            && PackagingUnitObj['Length' + imperialMetricText] != ""
            && parseInt(PackagingUnitObj['Length' + imperialMetricText]) != 0;
        const packagingUomValue = renderItems.UnitsOfMeasure.PackagingUnit.PackagingUom;
        const isPackagingUomUnspecified = packagingUomValue == null || packagingUomValue === 0 || packagingUomValue === '' || packagingUomValue === 'Unspecified';
        return (
            <div className={"collapseItemsTabContent_wrapper"} id={'collapseItemsUofM'}>

                <WmsCollapse
                    id={'ItemUofM'}
                    headerLabel={this.translate("Label_Measurement_System")}
                    showCollapseText={false}
                    showCollapseIcon={false} >

                    <WmsRadio
                        id="IsImperial"
                        name="IsImperial"
                        label={this.translate('Label_US_Imperial')}
                        wmsSelector={this.state.Selector + 'IsImperial'}
                        onChangeFunc={(e) => this.handleChange('UnitsOfMeasure', e)}
                        value={renderItems.UnitsOfMeasure.IsImperial}
                        checked={renderItems.UnitsOfMeasure.IsImperial == true}
                    />

                    <WmsRadio
                        id="metric"
                        name="IsImperial"
                        label={this.translate('Label_Metric')}
                        wmsSelector={this.state.Selector + ''}
                        onChangeFunc={(e) => this.handleChange('UnitsOfMeasure', e)}
                        value={renderItems.UnitsOfMeasure.IsImperial}
                        checked={renderItems.UnitsOfMeasure.IsImperial != true}
                    />

                </WmsCollapse>
                <h4 className='subsection-header-of-collapse'>{this.translate("Label_Inventory_units_of_measure")}</h4>

                <WmsCollapse
                    id={'ItemInventoryUofMPrimaryUnit'}
                    headerLabel={this.translate("Label_Primary_Unit_label")}
                    showCollapseText={false}
                    showCollapseIcon={false} >

                    <div className={" wms_primaryunitType_wrap"}>
                        <div className="uom-wrapper">
                            <WmsDropdown
                                id="PrimaryUnitType"
                                name="PrimaryUnitType"
                                label={this.translate('Label_Primary_Unit_of_Measure')}
                                wmsSelector={this.state.Selector + "TypeOfUnitOptions"}
                                onChangeFunc={(e) => this.handleChange('InventoryUnitOfMeasure', e)}
                                value={renderItems.UnitsOfMeasure.InventoryUnitOfMeasure.PrimaryUnitType == null ? 0 : renderItems.UnitsOfMeasure.InventoryUnitOfMeasure.PrimaryUnitType}
                                options={this.props.sharedItemOptions.TypeOfUnitOptions}
                                valueField='Name'
                                textField='Name'
                                parentClassName='form_group'
                                blankFirstOption={true}
                                blankFirstOptionText="Unspecified"
                                extraWrapperClass="unit-type-option-wrapper" />

                            {this.renderStandardizedProductIdField({
                                label: this.translate('Label_Standardized_Product_Id'),
                                typeId: 'PrimaryStandardizedProductIdType',
                                typeName: 'StandardizedProductIdType',
                                typeValue: renderItems.ItemBasics.Description.StandardizedProductIdType,
                                typeOnChange: (e) => this.handleItemBasicChange('Description', e),
                                typeSelector: this.state.Selector + 'PrimaryStandardizedProductIdType',
                                upcId: 'Upc',
                                upcName: 'Upc',
                                upcValue: renderItems.ItemBasics.Description.Upc,
                                upcOnChange: (e) => this.handleItemBasicChange('Description', e),
                                upcSelector: this.state.Selector + 'PrimaryUnitUpc'
                            })}

                        </div>
                        {
                            this.state.Rights.hasOwnProperty("UxPrototypingDirectivesCartonization") &&
                            renderItems.UnitsOfMeasure.InventoryUnitOfMeasure.PrimaryUnitType && (
                            <>
                                <div>
                                    <WmsInput
                                        id="PackagingLength"
                                        inputName={'Length' + imperialMetricText}
                                        label={this.translate('Label_Length') + ' (' + (
                                            (imperialMetricText == 'Imperial') ?
                                                this.translate('Label_Inch_Abbrev_Wihtout_dot') :
                                                this.translate('Label_Centimeter_Abbrev_Wihtout_dot')
                                        ) + ')'}
                                        wmsSelector={this.state.Selector + "PackagingLength"}
                                        onChangeFunc={(e) => this.handleChangeForInventoryUnitTotalAreaVolume('PrimaryUnitOfMeasure', e)}
                                        value={renderItems.UnitsOfMeasure.InventoryUnitOfMeasure.PrimaryUnitOfMeasure['Length' + imperialMetricText]}
                                        extraWrapperClass="wms-input-height-width-length-box"
                                        required={renderItems.UnitsOfMeasure.InventoryUnitOfMeasure.PrimaryUnitOfMeasure.IsPrepackaged && this.state.Rights.hasOwnProperty("UxDirectivesPrePackedItems")}
                                        regularExp={/^[0-9]*(?:\.[0-9]{0,4})?$/} />

                                    <WmsInput
                                        id="PackagingWidth"
                                        inputName={'Width' + imperialMetricText}
                                        label={this.translate('Label_Width') + ' (' + (
                                            (imperialMetricText == 'Imperial') ?
                                                this.translate('Label_Inch_Abbrev_Wihtout_dot') :
                                                this.translate('Label_Centimeter_Abbrev_Wihtout_dot')
                                        ) + ')'}
                                        wmsSelector={this.state.Selector + "PackagingWidth"}
                                        onChangeFunc={(e) => this.handleChangeForInventoryUnitTotalAreaVolume('PrimaryUnitOfMeasure', e)}
                                        value={renderItems.UnitsOfMeasure.InventoryUnitOfMeasure.PrimaryUnitOfMeasure['Width' + imperialMetricText]}
                                        extraWrapperClass="wms-input-height-width-length-box"
                                        required={renderItems.UnitsOfMeasure.InventoryUnitOfMeasure.PrimaryUnitOfMeasure.IsPrepackaged && this.state.Rights.hasOwnProperty("UxDirectivesPrePackedItems")}
                                        regularExp={/^[0-9]*(?:\.[0-9]{0,4})?$/} />

                                    <WmsInput
                                        id="packagingHeight"
                                        inputName={'Height' + imperialMetricText}
                                        label={this.translate('Label_Height') + ' (' + (
                                            (imperialMetricText == 'Imperial') ?
                                                this.translate('Label_Inch_Abbrev_Wihtout_dot') :
                                                this.translate('Label_Centimeter_Abbrev_Wihtout_dot')
                                        ) + ')'}
                                        wmsSelector={this.state.Selector + "PackagingHeight"}
                                        onChangeFunc={(e) => this.handleChangeForInventoryUnitTotalAreaVolume('PrimaryUnitOfMeasure', e)}
                                        value={renderItems.UnitsOfMeasure.InventoryUnitOfMeasure.PrimaryUnitOfMeasure['Height' + imperialMetricText]}
                                        extraWrapperClass="wms-input-height-width-length-box"
                                        required={renderItems.UnitsOfMeasure.InventoryUnitOfMeasure.PrimaryUnitOfMeasure.IsPrepackaged && this.state.Rights.hasOwnProperty("UxDirectivesPrePackedItems")}
                                        regularExp={/^[0-9]*(?:\.[0-9]{0,4})?$/} />

                                    <WmsInput
                                        id="totalPrimaryArea"
                                        inputName="totalPrimaryArea"
                                        label={this.translate('Label_Total_Area') + ' (' + (
                                            (imperialMetricText == 'Imperial') ?
                                                this.translate('Label_Square_Feet_Abbrev') :
                                                this.translate('Label_Square_Meter_Abbrev')
                                        ) + ')'}
                                        wmsSelector={this.state.Selector + "totalPrimaryArea"}
                                        onChangeFunc={(e) => function () { }}
                                        extraWrapperClass="wms-input-total-area-box"
                                        value={renderItems.totalPrimaryArea} />

                                    <WmsInput
                                        id="totalPrimaryVolume"
                                        inputName="totalPrimaryVolume"
                                        label={this.translate('Label_Total_Volume') + ' (' + (
                                            (imperialMetricText == 'Imperial') ?
                                                this.translate('Label_Cubic_Feet_Abbrev') :
                                                this.translate('Label_Cubic_Meter_Abbrev')
                                        ) + ')'}
                                        wmsSelector={this.state.Selector + "totalPrimaryVolume"}
                                        onChangeFunc={(e) => function () { }}
                                        extraWrapperClass="wms-input-total-volume-box"
                                        value={renderItems.totalPrimaryVolume} />

                                    <WmsInput
                                        id="packagingWeight"
                                        inputName={'Weight' + imperialMetricText}
                                        label={this.translate('Label_Weight') + ' (' + (
                                            (imperialMetricText == 'Imperial') ?
                                                this.translate('Label_Pound_Abbrev') :
                                                this.translate('Label_Kilogram_Abbrev')
                                        ) + ')'}
                                        wmsSelector={this.state.Selector + "PackagingWeight"}
                                        onChangeFunc={(e) => this.handleChangeForInventoryUnitTotalAreaVolume('PrimaryUnitOfMeasure',e)}
                                        value={renderItems.UnitsOfMeasure.InventoryUnitOfMeasure.PrimaryUnitOfMeasure['Weight' + imperialMetricText]}
                                        extraWrapperClass="wms-input-total-and-weight-box"
                                        required={renderItems.UnitsOfMeasure.InventoryUnitOfMeasure.PrimaryUnitOfMeasure.IsPrepackaged && this.state.Rights.hasOwnProperty("UxDirectivesPrePackedItems")}
                                        regularExp={/^[0-9]*(?:\.[0-9]{0,4})?$/} />

                                    <WmsInput
                                        id="PackagingNetWeight"
                                        inputName={'NetWeight' + imperialMetricText}
                                        label={this.translate('Label_Net_Weight') + ' (' + (
                                            (imperialMetricText == 'Imperial') ?
                                                this.translate('Label_Pound_Abbrev') :
                                                this.translate('Label_Kilogram_Abbrev')
                                        ) + ')'}
                                        wmsSelector={this.state.Selector + "PackagingNetWeight"}
                                        onChangeFunc={(e) => this.handleChangeForInventoryUnitTotalAreaVolume('PrimaryUnitOfMeasure',e)}
                                        value={renderItems.UnitsOfMeasure.InventoryUnitOfMeasure.PrimaryUnitOfMeasure['NetWeight' + imperialMetricText]}
                                        extraWrapperClass="wms-input-weight-box"
                                        regularExp={/^[0-9]*(?:\.[0-9]{0,4})?$/} />
                                </div>
                                <div className='info-text-wrapper'>
                                    <i className="fa fa-info-circle" aria-hidden="true"></i>
                                    Primary Unit of Measure dimensions and weight are currently only used for cartonization.
                                </div>
                            </>
                        )}
                    </div>
                </WmsCollapse>
                <WmsCollapse
                        id={'ItemInventoryUofMSecondaryUnit'}
                        headerLabel={this.translate("Label_Secondary_Unit_label")}
                        showCollapseText={false}
                        showCollapseIcon={false} >
                    <div className={" wms_primaryunitType_wrap"}>
                    <div className="secondary-uom-wrapper">
                        <div className={(renderItems.UnitsOfMeasure.InventoryUnitOfMeasure.UseSecondaryUnit == true ? "" : " wms_secondary_uom") + " wms_checkbox_wrap"}>
                            <WmsCheckBox
                                id="UseSecondaryUnit"
                                name="UseSecondaryUnit"
                                label={this.translate('Label_Use_Secondary')}
                                wmsSelector={this.state.Selector + "UseSecondaryUnit"}
                                onChangeFunc={(e) => this.handleChange('InventoryUnitOfMeasure', e)}
                                value={renderItems.UnitsOfMeasure.InventoryUnitOfMeasure.UseSecondaryUnit}
                                checked={renderItems.UnitsOfMeasure.InventoryUnitOfMeasure.UseSecondaryUnit == true}
                                isRounded={true} />
                        </div>
                    </div>

                    {renderItems.UnitsOfMeasure.InventoryUnitOfMeasure.UseSecondaryUnit == true && (
                           <>
                            <div className="wms_measure_wrap">
                                <WmsDropdown
                                    id="SecondaryUnitType"
                                    name="SecondaryUnitType"
                                    label={this.translate('Label_Secondary_Unit_of_Measure')}
                                    wmsSelector={this.state.Selector + "SelectedSecondaryUnitType"}
                                    onChangeFunc={(e) => this.handleChange('InventoryUnitOfMeasure', e)}
                                    value={renderItems.UnitsOfMeasure.InventoryUnitOfMeasure.SecondaryUnitType == null ?
                                        0 : renderItems.UnitsOfMeasure.InventoryUnitOfMeasure.SecondaryUnitType}
                                    options={this.props.sharedItemOptions.TypeOfUnitOptions}
                                    required={!renderItems.UnitsOfMeasure.InventoryUnitOfMeasure.SecondaryUnitType}
                                    valueField='Name'
                                    textField='Name'
                                    parentClassName='form_group'
                                    blankFirstOption={true}
                                    blankFirstOptionText="Unspecified"
                                    extraWrapperClass="unit-type-option-wrapper" />

                                <WmsInput
                                    id="PrimaryUnitsPerSecondaryUnit"
                                    inputName="PrimaryUnitsPerSecondaryUnit"
                                    label={this.translate('Label_Primary_Units_Per_Secondary_UOM')}
                                    wmsSelector={this.state.Selector + "PrimaryUnitsPerSecondaryUnit"}
                                    onChangeFunc={(e) => this.handleChange('InventoryUnitOfMeasure', e)}
                                    value={renderItems.UnitsOfMeasure.InventoryUnitOfMeasure.PrimaryUnitsPerSecondaryUnit}
                                    regularExp={/^[0-9]*(?:\.[0-9]{0,4})?$/}
                                    extraWrapperClass={`primary-units-per-secondary-unit ${this.props.validUnitOfMeuser()? 'invalid-input' : ''}`}
                                    required={true} />

                                {this.renderStandardizedProductIdField({
                                    label: this.translate('Label_Secondary_Standardized_Product_Id'),
                                    typeId: 'SecondaryStandardizedProductIdType',
                                    typeName: 'SecondaryStandardizedProductIdType',
                                    typeValue: renderItems.ItemBasics.Description.SecondaryStandardizedProductIdType,
                                    typeOnChange: (e) => this.handleItemBasicChange('Description', e),
                                    typeSelector: this.state.Selector + 'SecondaryStandardizedProductIdType',
                                    upcId: 'SecondaryUnitUpc',
                                    upcName: 'SecondaryUnitUpc',
                                    upcValue: renderItems.ItemBasics.Description.SecondaryUnitUpc,
                                    upcOnChange: (e) => this.handleItemBasicChange('Description', e),
                                    upcSelector: this.state.Selector + 'SecondaryUnitUpc',
                                    disabled: isAllowDuplicatedUPC
                                })}

                            </div>
                                {
                                    this.state.Rights.hasOwnProperty("UxPrototypingDirectivesCartonization") &&
                                    renderItems.UnitsOfMeasure.InventoryUnitOfMeasure.SecondaryUnitType && (
                                <>
                                    <div className='secondary-measurement-fields'>
                                        <WmsInput
                                            id="PackagingLength"
                                            inputName={'Length' + imperialMetricText}
                                            label={this.translate('Label_Length') + ' (' + (
                                                (imperialMetricText == 'Imperial') ?
                                                    this.translate('Label_Inch_Abbrev_Wihtout_dot') :
                                                    this.translate('Label_Centimeter_Abbrev_Wihtout_dot')
                                            ) + ')'}
                                            wmsSelector={this.state.Selector + "PackagingLength"}
                                            onChangeFunc={(e) => this.handleChangeForInventoryUnitTotalAreaVolume('SecondaryUnitOfMeasure', e)}
                                            value={renderItems.UnitsOfMeasure.InventoryUnitOfMeasure.SecondaryUnitOfMeasure ? renderItems.UnitsOfMeasure.InventoryUnitOfMeasure.SecondaryUnitOfMeasure['Length' + imperialMetricText] : ""}
                                            extraWrapperClass="wms-input-height-width-length-box"
                                            required={renderItems.UnitsOfMeasure.InventoryUnitOfMeasure.SecondaryUnitOfMeasure ? renderItems.UnitsOfMeasure.InventoryUnitOfMeasure.SecondaryUnitOfMeasure.IsPrepackaged && this.state.Rights.hasOwnProperty("UxDirectivesPrePackedItems") : false}
                                            regularExp={/^[0-9]*(?:\.[0-9]{0,4})?$/} />

                                        <WmsInput
                                            id="PackagingWidth"
                                            inputName={'Width' + imperialMetricText}
                                            label={this.translate('Label_Width') + ' (' + (
                                                (imperialMetricText == 'Imperial') ?
                                                    this.translate('Label_Inch_Abbrev_Wihtout_dot') :
                                                    this.translate('Label_Centimeter_Abbrev_Wihtout_dot')
                                            ) + ')'}
                                            wmsSelector={this.state.Selector + "PackagingWidth"}
                                            onChangeFunc={(e) => this.handleChangeForInventoryUnitTotalAreaVolume('SecondaryUnitOfMeasure', e)}
                                            value={renderItems.UnitsOfMeasure.InventoryUnitOfMeasure.SecondaryUnitOfMeasure ? renderItems.UnitsOfMeasure.InventoryUnitOfMeasure.SecondaryUnitOfMeasure['Width' + imperialMetricText]: ""}
                                            extraWrapperClass="wms-input-height-width-length-box"
                                            required={renderItems.UnitsOfMeasure.InventoryUnitOfMeasure.SecondaryUnitOfMeasure ? renderItems.UnitsOfMeasure.InventoryUnitOfMeasure.SecondaryUnitOfMeasure.IsPrepackaged  && this.state.Rights.hasOwnProperty("UxDirectivesPrePackedItems") : false}
                                            regularExp={/^[0-9]*(?:\.[0-9]{0,4})?$/} />

                                        <WmsInput
                                            id="packagingHeight"
                                            inputName={'Height' + imperialMetricText}
                                            label={this.translate('Label_Height') + ' (' + (
                                                (imperialMetricText == 'Imperial') ?
                                                    this.translate('Label_Inch_Abbrev_Wihtout_dot') :
                                                    this.translate('Label_Centimeter_Abbrev_Wihtout_dot')
                                            ) + ')'}
                                            wmsSelector={this.state.Selector + "PackagingHeight"}
                                            onChangeFunc={(e) => this.handleChangeForInventoryUnitTotalAreaVolume('SecondaryUnitOfMeasure', e)}
                                            value={renderItems.UnitsOfMeasure.InventoryUnitOfMeasure.SecondaryUnitOfMeasure ? renderItems.UnitsOfMeasure.InventoryUnitOfMeasure.SecondaryUnitOfMeasure['Height' + imperialMetricText] : ""}
                                            extraWrapperClass="wms-input-height-width-length-box"
                                            required={renderItems.UnitsOfMeasure.InventoryUnitOfMeasure.SecondaryUnitOfMeasure ? renderItems.UnitsOfMeasure.InventoryUnitOfMeasure.SecondaryUnitOfMeasure.IsPrepackaged  && this.state.Rights.hasOwnProperty("UxDirectivesPrePackedItems") : false}
                                            regularExp={/^[0-9]*(?:\.[0-9]{0,4})?$/} />

                                        <WmsInput
                                            id="totalSecondaryArea"
                                            inputName="totalSecondaryArea"
                                            label={this.translate('Label_Total_Area') + ' (' + (
                                                (imperialMetricText == 'Imperial') ?
                                                    this.translate('Label_Square_Feet_Abbrev') :
                                                    this.translate('Label_Square_Meter_Abbrev')
                                            ) + ')'}
                                            wmsSelector={this.state.Selector + "totalSecondaryArea"}
                                            onChangeFunc={(e) => function () { }}
                                            extraWrapperClass="wms-input-total-area-box"
                                            value={renderItems.totalSecondaryArea} />

                                        <WmsInput
                                            id="totalSecondaryVolume"
                                            inputName="totalSecondaryVolume"
                                            label={this.translate('Label_Total_Volume') + ' (' + (
                                                (imperialMetricText == 'Imperial') ?
                                                    this.translate('Label_Cubic_Feet_Abbrev') :
                                                    this.translate('Label_Cubic_Meter_Abbrev')
                                            ) + ')'}
                                            wmsSelector={this.state.Selector + "totalSecondaryVolume"}
                                            onChangeFunc={(e) => function () { }}
                                            extraWrapperClass="wms-input-total-volume-box"
                                            value={renderItems.totalSecondaryVolume} />

                                        <WmsInput
                                            id="packagingWeight"
                                            inputName={'Weight' + imperialMetricText}
                                            label={this.translate('Label_Weight') + ' (' + (
                                                (imperialMetricText == 'Imperial') ?
                                                    this.translate('Label_Pound_Abbrev') :
                                                    this.translate('Label_Kilogram_Abbrev')
                                            ) + ')'}
                                            wmsSelector={this.state.Selector + "PackagingWeight"}
                                            onChangeFunc={(e) => this.handleChangeForInventoryUnitTotalAreaVolume('SecondaryUnitOfMeasure', e)}
                                            value={renderItems.UnitsOfMeasure.InventoryUnitOfMeasure.SecondaryUnitOfMeasure ? renderItems.UnitsOfMeasure.InventoryUnitOfMeasure.SecondaryUnitOfMeasure['Weight' + imperialMetricText]: ""}
                                            extraWrapperClass="wms-input-total-and-weight-box"
                                            required={renderItems.UnitsOfMeasure.InventoryUnitOfMeasure.SecondaryUnitOfMeasure ? renderItems.UnitsOfMeasure.InventoryUnitOfMeasure.SecondaryUnitOfMeasure.IsPrepackaged  && this.state.Rights.hasOwnProperty("UxDirectivesPrePackedItems") : false}
                                            regularExp={/^[0-9]*(?:\.[0-9]{0,4})?$/} />

                                        <WmsInput
                                            id="PackagingNetWeight"
                                            inputName={'NetWeight' + imperialMetricText}
                                            label={this.translate('Label_Net_Weight') + ' (' + (
                                                (imperialMetricText == 'Imperial') ?
                                                    this.translate('Label_Pound_Abbrev') :
                                                    this.translate('Label_Kilogram_Abbrev')
                                            ) + ')'}
                                            wmsSelector={this.state.Selector + "PackagingNetWeight"}
                                            onChangeFunc={(e) => this.handleChangeForInventoryUnitTotalAreaVolume('SecondaryUnitOfMeasure', e)}
                                            value={renderItems.UnitsOfMeasure.InventoryUnitOfMeasure.SecondaryUnitOfMeasure ? renderItems.UnitsOfMeasure.InventoryUnitOfMeasure.SecondaryUnitOfMeasure['NetWeight' + imperialMetricText] : ""}
                                            extraWrapperClass="wms-input-weight-box"
                                            regularExp={/^[0-9]*(?:\.[0-9]{0,4})?$/} />
                                    </div>
                                    <div className='info-text-wrapper'>
                                        <i className="fa fa-info-circle" aria-hidden="true"></i>
                                        Secondary Unit of Measure dimensions and weight are currently only used for cartonization.
                                    </div>
                                </>
                            )}
                        </>
                    )}
                    </div>
                    {/* )} */}



                </WmsCollapse>

                <WmsCollapse
                    id={'ItemUofMPackagingUnit'}
                    headerLabel={this.translate("Label_Packaging_Unit")}
                    showCollapseText={false}
                    showCollapseIcon={false} >

                    {/* set customer sor in options orderBy:customSort */}
                    <div className="uom-wrapper">
                        <WmsDropdown
                            id="PackagingUom"
                            name="PackagingUom"
                            label={this.translate('Label_Packaging_Unit_Measure')}
                            wmsSelector={this.state.Selector + "PackagingUom"}
                            onChangeFunc={(e) => this.handleChange('PackagingUnit', e)}
                            value={renderItems.UnitsOfMeasure.PackagingUnit.PackagingUom == null ? 0 : renderItems.UnitsOfMeasure.PackagingUnit.PackagingUom}
                            options={this.props.sharedItemOptions.TypeOfUnitOptions}
                            valueField='Name'
                            textField='Name'
                            extraWrapperClass="wms-dropdown-packaging-unit-uom-box"
                            parentClassName='form_group'
                            blankFirstOption={true}
                            blankFirstOptionText="Unspecified" />

                        <WmsInput
                            id="InventoryUnitsPerUnit"
                            inputName="InventoryUnitsPerUnit"
                            label={this.translate('Label_Primary_Units_Per_Packaging')}
                            wmsSelector={this.state.Selector + "InventoryUnitsPerUnit"}
                            onChangeFunc={(e) => this.handleChange('PackagingUnit', e)}
                            value={renderItems.UnitsOfMeasure.PackagingUnit.InventoryUnitsPerUnit}
                            extraWrapperClass={`wms-input-primary-box ${this.props.validInventoryUnitsPerUnit()? 'invalid-input' : ''}`}
                            regularExp={/^[0-9]*(?:\.[0-9]{0,4})?$/}
                            disabled={isPackagingUomUnspecified} />

                        {this.renderStandardizedProductIdField({
                            label: this.translate('Label_Packaging_Standardized_Product_Id'),
                            typeId: 'PackagingStandardizedProductIdType',
                            typeName: 'StandardizedProductIdType',
                            typeValue: renderItems.UnitsOfMeasure.PackagingUnit.StandardizedProductIdType != null
                                ? renderItems.UnitsOfMeasure.PackagingUnit.StandardizedProductIdType
                                : renderItems.ItemBasics.Description.LabelingStandardizedProductIdType,
                            typeOnChange: (e) => this.handleChange('PackagingUnit', e),
                            typeSelector: this.state.Selector + 'PackagingStandardizedProductIdType',
                            upcId: 'PackageUnitUpc',
                            upcName: 'Upc',
                            upcValue: renderItems.UnitsOfMeasure.PackagingUnit.Upc,
                            upcOnChange: (e) => this.handleChange('PackagingUnit', e),
                            upcSelector: this.state.Selector + 'PackageUnitUpc',
                            disabled: isAllowDuplicatedUPC || isPackagingUomUnspecified
                        })}
                    </div>
                    <WmsInput
                        id="PackagingLength"
                        inputName={'Length' + imperialMetricText}
                        label={this.translate('Label_Length') + ' (' + (
                            (imperialMetricText == 'Imperial') ?
                                this.translate('Label_Inch_Abbrev_Wihtout_dot') :
                                this.translate('Label_Centimeter_Abbrev_Wihtout_dot')
                        ) + ')'}
                        wmsSelector={this.state.Selector + "PackagingLength"}
                        onChangeFunc={(e) => this.handleChangeForTotalAreaVolume('PackagingUnit', e)}
                        value={renderItems.UnitsOfMeasure.PackagingUnit['Length' + imperialMetricText]}
                        extraWrapperClass="wms-input-height-width-length-box"
                        required={renderItems.UnitsOfMeasure.PackagingUnit.IsPrepackaged && this.state.Rights.hasOwnProperty("UxDirectivesPrePackedItems")}
                        regularExp={/^[0-9]*(?:\.[0-9]{0,4})?$/}
                        disabled={isPackagingUomUnspecified} />

                    <WmsInput
                        id="PackagingWidth"
                        inputName={'Width' + imperialMetricText}
                        label={this.translate('Label_Width') + ' (' + (
                            (imperialMetricText == 'Imperial') ?
                                this.translate('Label_Inch_Abbrev_Wihtout_dot') :
                                this.translate('Label_Centimeter_Abbrev_Wihtout_dot')
                        ) + ')'}
                        wmsSelector={this.state.Selector + "PackagingWidth"}
                        onChangeFunc={(e) => this.handleChangeForTotalAreaVolume('PackagingUnit', e)}
                        value={renderItems.UnitsOfMeasure.PackagingUnit['Width' + imperialMetricText]}
                        extraWrapperClass="wms-input-height-width-length-box"
                        required={renderItems.UnitsOfMeasure.PackagingUnit.IsPrepackaged  && this.state.Rights.hasOwnProperty("UxDirectivesPrePackedItems")}
                        regularExp={/^[0-9]*(?:\.[0-9]{0,4})?$/}
                        disabled={isPackagingUomUnspecified} />

                    <WmsInput
                        id="packagingHeight"
                        inputName={'Height' + imperialMetricText}
                        label={this.translate('Label_Height') + ' (' + (
                            (imperialMetricText == 'Imperial') ?
                                this.translate('Label_Inch_Abbrev_Wihtout_dot') :
                                this.translate('Label_Centimeter_Abbrev_Wihtout_dot')
                        ) + ')'}
                        wmsSelector={this.state.Selector + "PackagingHeight"}
                        onChangeFunc={(e) => this.handleChangeForTotalAreaVolume('PackagingUnit', e)}
                        value={renderItems.UnitsOfMeasure.PackagingUnit['Height' + imperialMetricText]}
                        extraWrapperClass="wms-input-height-width-length-box"
                        required={renderItems.UnitsOfMeasure.PackagingUnit.IsPrepackaged  && this.state.Rights.hasOwnProperty("UxDirectivesPrePackedItems")}
                        regularExp={/^[0-9]*(?:\.[0-9]{0,4})?$/}
                        disabled={isPackagingUomUnspecified} />

                    <WmsInput
                        id="totalArea"
                        inputName="totalArea"
                        label={this.translate('Label_Total_Area') + ' (' + (
                            (imperialMetricText == 'Imperial') ?
                                this.translate('Label_Square_Feet_Abbrev') :
                                this.translate('Label_Square_Meter_Abbrev')
                        ) + ')'}
                        wmsSelector={this.state.Selector + "totalArea"}
                        onChangeFunc={(e) => function () { }}
                        extraWrapperClass="wms-input-total-area-box"
                        value={renderItems.totalArea}
                        disabled={isPackagingUomUnspecified} />

                    <WmsInput
                        id="totalVolume"
                        inputName="totalVolume"
                        label={this.translate('Label_Total_Volume') + ' (' + (
                            (imperialMetricText == 'Imperial') ?
                                this.translate('Label_Cubic_Feet_Abbrev') :
                                this.translate('Label_Cubic_Meter_Abbrev')
                        ) + ')'}
                        wmsSelector={this.state.Selector + "totalVolume"}
                        onChangeFunc={(e) => function () { }}
                        extraWrapperClass="wms-input-total-volume-box"
                        value={renderItems.totalVolume}
                        disabled={isPackagingUomUnspecified} />

                    <WmsInput
                        id="packagingWeight"
                        inputName={'Weight' + imperialMetricText}
                        label={this.translate('Label_Weight') + ' (' + (
                            (imperialMetricText == 'Imperial') ?
                                this.translate('Label_Pound_Abbrev') :
                                this.translate('Label_Kilogram_Abbrev')
                        ) + ')'}
                        wmsSelector={this.state.Selector + "PackagingWeight"}
                        onChangeFunc={(e) => this.handleChange('PackagingUnit', e)}
                        value={renderItems.UnitsOfMeasure.PackagingUnit['Weight' + imperialMetricText]}
                        extraWrapperClass="wms-input-total-and-weight-box"
                        required={renderItems.UnitsOfMeasure.PackagingUnit.IsPrepackaged  && this.state.Rights.hasOwnProperty("UxDirectivesPrePackedItems")}
                        regularExp={/^[0-9]*(?:\.[0-9]{0,4})?$/}
                        disabled={isPackagingUomUnspecified} />

                    <WmsInput
                        id="PackagingNetWeight"
                        inputName={'NetWeight' + imperialMetricText}
                        label={this.translate('Label_Net_Weight') + ' (' + (
                            (imperialMetricText == 'Imperial') ?
                                this.translate('Label_Pound_Abbrev') :
                                this.translate('Label_Kilogram_Abbrev')
                        ) + ')'}
                        wmsSelector={this.state.Selector + "PackagingNetWeight"}
                        onChangeFunc={(e) => this.handleChange('PackagingUnit', e)}
                        value={renderItems.UnitsOfMeasure.PackagingUnit['NetWeight' + imperialMetricText]}
                        extraWrapperClass="wms-input-weight-box"
                        regularExp={/^[0-9]*(?:\.[0-9]{0,4})?$/}
                        disabled={isPackagingUomUnspecified} />
                        {this.state.Rights.hasOwnProperty("UxDirectivesPrePackedItems") && (
                            <>
                            <WmsCheckBox
                                id="IsPrepackaged"
                                name="IsPrepackaged"
                                label={this.translate('Label_This_item_is_pre_packaged')}
                                wmsSelector={this.state.Selector + "IsPrepackaged"}
                                onChangeFunc={(e) => this.handleChange('PackagingUnit', e)}
                                value={renderItems.UnitsOfMeasure.PackagingUnit.IsPrepackaged}
                                checked={renderItems.UnitsOfMeasure.PackagingUnit.IsPrepackaged}
                                isRounded={true}
                                disabled={!IsPrepackagedEnable}
                                showToolTip={!IsPrepackagedEnable}
                                tooltipText={this.translate('Label_This_item_is_pre_packaged_Tooltip')}
                                parentClassName="IsPrepackaged"
                                />
                            <span className={"IsPrepackaged_description_text " + (!IsPrepackagedEnable ? " disabled" : "")}>{this.translate('Label_This_item_is_pre_packaged_Description')}</span>
                            </>
                        )}

                </WmsCollapse>

                <WmsCollapse
                    id={'ItemUofMMovableUnit'}
                    headerLabel={this.state.customLabels.Label_Movable_Unit}
                    showCollapseText={false}
                    showCollapseIcon={false} >
                    <div className="uom-wrapper">

                        <WmsDropdown
                            id="MovableUnitUom"
                            name="MovableUnitUom"
                            label={this.state.customLabels.Label_Movable_Unit}
                            wmsSelector={this.state.Selector + "SelectedMovableUnitUom"}
                            onChangeFunc={(e) => this.handleMovableUnitSelectChange(e.target.value)}
                            value={renderItems.UnitsOfMeasure.MovableUnit.MovableUnitUomIndex}
                            options={this.props.sharedItemOptions.MovableUnitOptions}
                            textField='Name'
                            applyIndex={true}
                            parentClassName='form_group'
                            extraWrapperClass="wms-dropdown-packaging-unit-box"
                            blankFirstOption={true}
                            blankFirstOptionText="Unspecified" />

                        <WmsInput
                            id="Qty"
                            inputName="Qty"
                            label={this.translate('Label_Quantity_Primary_Units')}
                            wmsSelector={this.state.Selector + "MovableUnitQty"}
                            onChangeFunc={(e) => this.handleChange('MovableUnit', e)}
                            value={renderItems.UnitsOfMeasure.MovableUnit.Qty}
                            extraWrapperClass=""
                            regularExp={/^[0-9]*(?:\.[0-9]{0,4})?$/} />

                        {this.renderStandardizedProductIdField({
                            label: this.translate('Label_Movable_Standardized_Product_Id'),
                            typeId: 'MovableUnitStandardizedProductIdType',
                            typeName: 'StandardizedProductIdType',
                            typeValue: renderItems.UnitsOfMeasure.MovableUnit.StandardizedProductIdType,
                            typeOnChange: (e) => this.handleChange('MovableUnit', e),
                            typeSelector: this.state.Selector + 'MovableUnitStandardizedProductIdType',
                            upcId: 'MovableUnitUpc',
                            upcName: 'Upc',
                            upcValue: renderItems.UnitsOfMeasure.MovableUnit.Upc,
                            upcOnChange: (e) => this.handleChange('MovableUnit', e),
                            upcSelector: this.state.Selector + 'MovableUnitUpc',
                            disabled: isAllowDuplicatedUPC
                        })}
                    </div>

                    <WmsInput
                        id="MovableLength"
                        inputName={'Length' + imperialMetricText}
                        label={this.translate('Label_Length') + ' (' + ((imperialMetricText == 'Imperial') ? this.translate('Label_Inch_Abbrev_Wihtout_dot') : this.translate('Label_Centimeter_Abbrev_Wihtout_dot')) + ')'}
                        wmsSelector={this.state.Selector + "MovableLength"}
                        onChangeFunc={(e) => this.handleChange('MovableUnit', e)}
                        value={renderItems.UnitsOfMeasure.MovableUnit['Length' + imperialMetricText]}
                        extraWrapperClass="wms-input-height-width-length-box"
                        regularExp={/^[0-9]*(?:\.[0-9]{0,4})?$/} />

                    <WmsInput
                        id="MovableWidth"
                        inputName={'Width' + imperialMetricText}
                        label={this.translate('Label_Width') + ' (' + ((imperialMetricText == 'Imperial') ? this.translate('Label_Inch_Abbrev_Wihtout_dot') : this.translate('Label_Centimeter_Abbrev_Wihtout_dot')) + ')'}
                        wmsSelector={this.state.Selector + "MovableWidth"}
                        onChangeFunc={(e) => this.handleChange('MovableUnit', e)}
                        value={renderItems.UnitsOfMeasure.MovableUnit['Width' + imperialMetricText]}
                        extraWrapperClass="wms-input-height-width-length-box"
                        regularExp={/^[0-9]*(?:\.[0-9]{0,4})?$/} />

                    <WmsInput
                        id="MovableHeight"
                        inputName={'Height' + imperialMetricText}
                        label={this.translate('Label_Height') + ' (' + ((imperialMetricText == 'Imperial') ? this.translate('Label_Inch_Abbrev_Wihtout_dot') : this.translate('Label_Centimeter_Abbrev_Wihtout_dot')) + ')'}
                        wmsSelector={this.state.Selector + "MovableHeight"}
                        onChangeFunc={(e) => this.handleChange('MovableUnit', e)}
                        value={renderItems.UnitsOfMeasure.MovableUnit['Height' + imperialMetricText]}
                        extraWrapperClass="wms-input-height-width-length-box"
                        regularExp={/^[0-9]*(?:\.[0-9]{0,4})?$/} />

                    <WmsInput
                        id="Tie"
                        inputName="Tie"
                        label={this.translate('Label_TI')}
                        wmsSelector={this.state.Selector + "MovableUnitTie"}
                        onChangeFunc={this.handlechangeForQty}
                        value={renderItems.UnitsOfMeasure.MovableUnit.Tie}
                        extraWrapperClass="wms-input-total-and-weight-box"
                        regularExp={/^[0-9]*(?:\.[0-9]{0,4})?$/} />

                    <WmsInput
                        id="High"
                        inputName="High"
                        label={this.translate('Label_High')}
                        wmsSelector={this.state.Selector + "MovableUnitHigh"}
                        onChangeFunc={this.handlechangeForQty}
                        regularExp={/^[0-9]*(?:\.[0-9]{0,4})?$/}
                        extraWrapperClass="wms-input-total-and-weight-box"
                        value={renderItems.UnitsOfMeasure.MovableUnit.High} />

                    <WmsInput
                        id="movableWeight"
                        inputName={'Weight' + imperialMetricText}
                        label={this.translate('Label_Weight') + ' (' + ((imperialMetricText == 'Imperial') ? this.translate('Label_Pound_Abbrev') : this.translate('Label_Kilogram_Abbrev')) + ')'}
                        wmsSelector={this.state.Selector + "MovableWeight"}
                        onChangeFunc={(e) => this.handleChange('MovableUnit', e)}
                        regularExp={/^[0-9]*(?:\.[0-9]{0,4})?$/}
                        extraWrapperClass="wms-input-total-and-weight-box"
                        value={renderItems.UnitsOfMeasure.MovableUnit['Weight' + imperialMetricText]}
                    />


                </WmsCollapse>
                <h4 className='subsection-header-of-collapse'>{this.translate("Label_Inventory_management")}</h4>

                <WmsCollapse
                    id={'ItemUofMReplenishment'}
                    headerLabel={this.translate("Label_Replenishment")}
                    showCollapseText={false}
                    showCollapseIcon={false} >
                    <div className='replenishment-detail-form-wrapper'>
                        <p className='replenishment-panel-description'>{this.translate('Label_Replenishment_checkbox_extra_description')}</p>

                        <div className={'replenishment-section pick-line-replenishment-wrapper' + (picklineOn ? ' is-enabled' : ' is-disabled')}>
                            <div className='replenishment-section-header wms_checkbox_wrap'>
                                <WmsCheckBox
                                    id="UsePicklineReplenishment"
                                    name="UsePicklineReplenishment"
                                    label={this.translate('Label_Pick_line')}
                                    wmsSelector={this.state.Selector + "UsePicklineReplenishment"}
                                    onChangeFunc={() => this.handleReplenishmentSectionToggle('PicklineReplenishment')}
                                    value={picklineOn}
                                    checked={picklineOn}
                                    isRounded={true} />
                            </div>

                            <div className='replenishment-section-body'>
                                <div className='replenishment-setting-group-wrapper'>
                                    <span className='replenishment-allocate-pick-line-label group-area-label'>{this.translate('Label_Replenishment_allocate_pick_line_label')}</span>
                                    <ul className='replenishment-allocate-list'>
                                        <li className='replenishment-allocate-pick-line-value'>
                                            <div className='replenishment-allocate-pick-line-value-content'>
                                                <span>{this.translate('Label_Replenishment_allocate_pick_line_value')}</span>
                                                <WmsInput
                                                    id='MaxAllocateFromPickline'
                                                    inputName='MaxAllocateFromPickline'
                                                    wmsSelector={this.state.Selector + 'MaxAllocateFromPickline'}
                                                    onChangeFunc={this.handleChangeOfPickline}
                                                    value={renderItems.MaxAllocateFromPickline}
                                                    valueType={'number'}
                                                    disabled={!picklineOn}
                                                    required={picklineOn}
                                                    extraWrapperClass="max-allocate-input-wrapper no-lable-input" />
                                                <span className='replenishment-qty-units-label'>{primaryUnitsLabel}</span>
                                            </div>
                                        </li>
                                    </ul>
                                </div>

                                <p className='replenishment-qty-question group-area-label'>{this.translate('Label_Replenishment_pick_line_qty_question')}</p>
                                {this.renderQtyRow('PicklineMin', renderItems.PicklineMin, minLabel, !picklineOn, picklineOn, renderItems.PicklineMinPackagingUnit, packagingUnitsLabel, primaryUnitsLabel)}
                                {this.renderQtyRow('PicklineMax', renderItems.PicklineMax, maxLabel, !picklineOn, picklineOn, renderItems.PicklineMaxPackagingUnit, packagingUnitsLabel, primaryUnitsLabel)}
                            </div>
                        </div>

                        <div className={'replenishment-section bulk-storage-replenishment-wrapper' + (bulkOn ? ' is-enabled' : ' is-disabled')}>
                            <div className='replenishment-section-header wms_checkbox_wrap'>
                                <WmsCheckBox
                                    id="UseBulkStorageReplenishment"
                                    name="UseBulkStorageReplenishment"
                                    label={this.translate('Label_Bulk_storage')}
                                    wmsSelector={this.state.Selector + "UseBulkStorageReplenishment"}
                                    onChangeFunc={() => this.handleReplenishmentSectionToggle('BulkStorageReplenishment')}
                                    value={bulkOn}
                                    checked={bulkOn}
                                    isRounded={true} />
                            </div>

                            <div className='replenishment-section-body'>
                                <p className='replenishment-qty-question group-area-label'>{this.translate('Label_Replenishment_bulk_storage_qty_question')}</p>
                                {this.renderQtyRow('BulkStorageMin', renderItems.BulkStorageMin, minLabel, !bulkOn, bulkOn, renderItems.BulkStorageMinMus, musLabel, primaryUnitsLabel)}
                                {this.renderQtyRow('BulkStorageMax', renderItems.BulkStorageMax, maxLabel, !bulkOn, bulkOn, renderItems.BulkStorageMaxMus, musLabel, primaryUnitsLabel)}
                            </div>
                        </div>
                    </div>

                </WmsCollapse>
                <div>&nbsp;</div>

            </div>
        )
    }
}